export default "__VITE_ASSET__CZnSdIHj__"